import React from "react";
import "./style.css";

const VaporFormItem = props => {
  const { label, children } = props;
  return (
    <div className="dbx-vapor-form-item">
      <div className="dbx-vapor-form-item-label">{label}{!label ? <>&nbsp;</> : null}</div>
      <div className="dbx-vapor-form-item-widget">{children}</div>
    </div>
  );
};

export default VaporFormItem;
